import { render, staticRenderFns } from "./miniprogramLink.vue?vue&type=template&id=2e6d3e7c&scoped=true"
import script from "./miniprogramLink.vue?vue&type=script&lang=js"
export * from "./miniprogramLink.vue?vue&type=script&lang=js"
import style0 from "./miniprogramLink.vue?vue&type=style&index=0&id=2e6d3e7c&prod&scoped=true&lang=css"
import style1 from "./miniprogramLink.vue?vue&type=style&index=1&id=2e6d3e7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6d3e7c",
  null
  
)

export default component.exports